<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Create New Customer</h2>
  </div>
  <app-customer-form
    [form]="form"
    [isCreateMode]="true"
    submitButtonText="Create Customer"
    (submit)="onSubmit()"
    (cancel)="onCancel()">
  </app-customer-form>
</div>
